<ng-container *ngIf="recommendedThematics.length">
    <p class="margin-top margin-bottom text-bold text-center">Parcours recommandés</p>
    
    <div class="margin-top thematics-container custom-gap center-children-vertically">
        <div class="thematic-card" *ngFor="let thematic of recommendedThematics">
            <app-content-thematic
                [imageHeight]="300" 
                [imageWidth]="450"
                class="margin-top-xl" 
                [thematic]="thematic"></app-content-thematic>
        </div>
    </div>
    
    <div class="button-container">
        <app-button *ngIf="hasDoneInitialTest" class="margin-top margin-bottom" [outline]="true" icon="arrow-right" (onClick)="goToOrientationPage()">Être orienté.e par un coach</app-button>
    </div>
</ng-container>